module.exports = __webpack_public_path__ + "static/bgAccount.51bffd0f.png";